export const initAppConfig = (config, clearConfig) => ({
  type: 'INIT_CONFIG',
  config,
  clearConfig,
});

export const initFieldNaming = (uiLabels) => ({
  type: 'INIT_FIELD_NAMING',
  uiLabels,
});

export const updateLabel = (uiLabel) => ({
  type: 'UPDATE_UI_LABELS',
  uiLabel,
});
